/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-05-16 20:54:38
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-04-18 18:20:41
 * @FilePath: \baishu_react_ui\src\components\dashboard\BsyDashboardCustomApp\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";
import { BsyUtils } from '../../../utils/Utils';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import emptyImg from '../../../images/img_wugongzuo.png'
import './index.css';


export default class BsyDesignSetIconPane extends Component {
    static defaultProps = {
        colors: [3, 5, 1, 2, 0, 4],
        icons: [25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72],
        selectColor: 3,
        selectIcon: 0,
        setType: "system",
        imageIcon: ""
    }

    constructor(props) {
        super(props);
        this.state = {
            selectColor: props.selectColor,
            selectIcon: props.selectIcon,
            imageIcon: props.imageIcon,
            setType: (props.setType !== "system" && props.setType !== "image") ? "system" : props.setType
        }
        this.cropper = React.createRef();
        this.fileInput = React.createRef();
    }

    handleFileChange = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = () => {
            this.setState({ imageIcon: reader.result });
          };
          reader.readAsDataURL(file);
        }
    };

    handleCrop = (e) => {
        if (e)
            this.setState({
                cropResult: this.cropper.current.cropper.getCroppedCanvas({
                width: 200,
                height: 200}).toDataURL("image/png"),
            });
        else {
            if (typeof this.cropper.current.cropper.getCroppedCanvas() === 'undefined') {
                return;
              }
              this.setState({
                cropResult: this.cropper.current.cropper.getCroppedCanvas({
                  width: 200,
                  height: 200}).toDataURL("image/png"),
              });
        }
        this.props.setChange && this.props.setChange({cropResult: this.state.cropResult, setType: this.state.setType})
    };

    render() {
        const { selectColor, selectIcon, setType, imageIcon } = this.state;
        const { colors, icons } = this.props;
        return (
            <div className={"BsyDesignSetIconPane"}>
                <div className="design-set-icon-menu">
                    <div className={`menu-item ${setType === "system" ? "select" : ""}`} onClick={()=>{this.setState({setType: "system"})}}>
                        <span>{React.language("modify.system.icon")}</span>
                    </div>
                    <div className={`menu-item ${setType === "image" ? "select" : ""}`} onClick={()=>{this.setState({setType: "image"})}}>
                        <span>{React.language("speedy.entry.entryItem.customIcon")}</span>
                    </div>
                </div>
                <div className="design-set-icon-pane">
                    {setType === "image" && <div className="set-image-pane">
                        {!!imageIcon && <>
                            <Cropper
                                ref={this.cropper}
                                src={imageIcon}
                                style={{
                                    width: 300,
                                    height: 234
                                }}
                                dragMode={"none"}
                                aspectRatio={1}
                                autoCropArea={1}
                                viewMode={1}
                                minCropBoxWidth={24}
                                minCropBoxHeight={24}
                                zoomable={!1}
                                checkOrientation={!1}
                                ready={() => {
                                    this.handleCrop()
                                }}
                                cropend={() => {
                                    this.handleCrop()
                                }}
                                // 可以在这里设置其他 Cropper 选项
                            />
                        </>}
                        {!imageIcon && <>
                            <img className="emptyImg" src={emptyImg} alt="" />
                        </>}
                        <div className="openFile-btn" onClick={()=>{
                            this.fileInput.current && this.fileInput.current.click();
                        }}>
                            <i className="icon-widget-upload"></i>
                            <span>{!imageIcon ? React.language('modify.upload.icon') : React.language('avatar.image.change')}</span>
                        </div>
                        <input ref={this.fileInput} style={{"display": "none"}} type="file" accept="image/*" onChange={this.handleFileChange} />
                        <div className="empty-tip">{React.language('modify.upload.maxLimit')}</div>
                        <div className="empty-tip">{React.language('image.upload.size.tip', {width: 100, height: 100})}</div>
                    </div>}
                    {setType === "system" && <div className="set-icon-pane">
                        <div className="color-box">
                            {
                                colors.map(res =>{
                                    return <div className={`menu-item color-cover-${res} ${selectColor === res ? "selected" : ""}`} onClick={()=>{
                                        this.setState({selectColor: res})
                                        this.props.setChange && this.props.setChange({selectIcon: selectIcon, selectColor: res, setType: setType})
                                    }}></div>
                                })
                            }
                        </div>
                        <div className="icon-box">
                            <div className="box-cont">
                                {
                                    icons.map(res =>{
                                        return <div className={`menu-item color-cover-${selectColor} ${selectIcon === res ? "selected" : ""}`} onClick={()=>{
                                            this.setState({selectIcon: res})
                                            this.props.setChange && this.props.setChange({selectIcon: res, selectColor: selectColor, setType: setType})
                                        }}>
                                            <div className={`imgbg-bby-app imgbg-bby-app-${res}`}></div>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    </div>}
                </div>
                <div className="design-set-icon-footer">
                    <div className="footer-btn cancel" onClick={this.props.onCancel}>
                        <span>{React.language("cancel")}</span>
                    </div>
                    <div className="footer-btn ok" onClick={this.props.onOk}>
                        <span>{React.language("ok")}</span>
                    </div>
                </div>
            </div>
        )
    }
}